import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Topups } from './Topups';
import ReactGA from "react-ga4";

const token = document.getElementById('valor').getAttribute('value');
const payProp = document.getElementById('payProp').getAttribute('value');

ReactGA.initialize("G-782FGE60MB");

ReactDOM.render(
    <Topups token1 = { token } pay1 = {payProp}/>,
    document.getElementById('root')
);


